import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';
import { ModuleDataWithBootstrap } from 'common/bento/lib/bootstrap/types';
import { CompanyContextType } from 'common/hooks/useCompanyContext/types';
import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

import { VerificationModuleDataQuery } from '../graphql/queries/verificationModuleData.gql';

export interface VerificationModuleData extends ModuleDataWithBootstrap {
  companyContext: CompanyContextType;
  verificationData: VerificationModuleDataQuery;
  /**
   * Whether the user is the one that started the flow (eg. an account holder or a mandatee)
   */
  isMainApplicant: boolean;
  isShineStart: boolean;
  applicantType: ApplicantType;
  applicationType: ApplicationType;
}

const initialContext = {
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
} as { getModuleData: () => VerificationModuleData };

export type Context = typeof initialContext;

const model = createModel(
  initialContext,

  {
    events: {
      ...baseEvents,
      GO_AGREEMENT: () => ({}),
      GO_BENEFICIARIES: () => ({}),
      GO_BENEFICIARIES_REGISTER: () => ({}),
      GO_COMPANY_CREATION_DOCS: () => ({}),
      GO_COMPANY_FINANCIAL_INFO: () => ({}),
      GO_COMPANY_REGISTRATION: () => ({}),
      GO_COMPLIANCE_AND_PERSONAL_ADDRESS: () => ({}),
      GO_DRAFT_STATUTES: () => ({}),
      GO_IDENTITY: () => ({}),
      GO_MANDATE: () => ({}),
      GO_PRICING_PLAN: () => ({}),
      GO_PROOF_OF_ADDRESS: () => ({}),
      GO_PROOF_OF_FUNDS: () => ({}),
      GO_QES: () => ({}),
      GO_SHINE_START_VERIFICATION: () => ({}),
      GO_STATUTES: () => ({}),
    },
  },
);

export default model;

export type Model = typeof model;
